import React from 'react';
import PropTypes from 'prop-types';
import styles from './QuizProgressBar.css';

function QuizProgressBar({ isActive, currentSlideIndex, totalSlides }) {
    return (
        <div className={styles.root}>
            <div className={styles.line}>
                {isActive && (
                    <div className={styles.lineActive} style={{ width: currentSlideIndex ? `${currentSlideIndex / totalSlides * 100}%` : 10 }} />
                )}
            </div>
        </div>
    );
}

QuizProgressBar.propTypes = {
    isActive: PropTypes.bool,
    currentSlideIndex: PropTypes.number,
    totalSlides: PropTypes.number
};

export { QuizProgressBar };
